import { links } from './Links';
import { getServerUrl } from '../../utils/serverHours';
import { Link, NavLink } from 'react-router-dom';
import logo from '../../assets/Header-transparent-black-R.webp'




import playStoreLogo from '../../assets/ps.webp'
import appleStoreLogo from '../../assets/as.webp'
import { useEffect, useRef, useState } from 'react'
import { ArrowUpRight, ChevronRight, LogIn, UserPlus } from 'lucide-react'

const Header = () => {
    const [open, setOpen] = useState(false);
    const [portalOpen, setPortalOpen] = useState(false);
    const [activePortalSection, setActivePortalSection] = useState(null);
    const portalDropdownRef = useRef(null);

    useEffect(() => {
        const navbar = document.getElementById("navbar");

        const handleScroll = () => {
            if (window.scrollY > 50) {
                navbar?.classList.add("top-nav-collapse");
            } else {
                navbar?.classList.remove("top-nav-collapse");

            }
        };

        handleScroll();
        window.addEventListener("scroll", handleScroll);

        const handleOutsidePointerDown = (event) => {
            if (!portalDropdownRef.current?.contains(event.target)) {
                setPortalOpen(false);
                setActivePortalSection(null);
            }
        };

        document.addEventListener('pointerdown', handleOutsidePointerDown);

        return () => {
            window.removeEventListener("scroll", handleScroll);
            document.removeEventListener('pointerdown', handleOutsidePointerDown);
        };
    }, []);


    const loginLinks = links.filter(({ name }) =>
        name.includes('Login') || name.includes('Payout')
    );

    const registrationLinks = links.filter(({ name }) =>
        name.includes('Registration')
    );

    const portalSections = [
        {
            id: 'login',
            title: 'Login',
            copy: 'Access DSA, sales, payout and senior portals',
            Icon: LogIn,
        },

        {
            id: 'registration',
            title: 'Registration',
            copy: 'Create banker, DSA and associate registrations',
            Icon: UserPlus,
        },
    ];




    const openPortalMenu = (section) => {
        if (section) {
            setActivePortalSection(section);
        }

        setPortalOpen(true);
    };

    const handlePortalKeyDown = (event) => {
        if (event.key === 'Escape') {
            setPortalOpen(false);
            setActivePortalSection(null);
        }
    };

    const closeMobileMenu = () => {
        setOpen(false);
        setPortalOpen(false);
        setActivePortalSection(null);
    };

    return (
        <nav className="navbar fixed-top" id="navbar">
            <div className="container sm:px-4 lg:px-8 flex flex-wrap items-center justify-between lg:flex-nowrap">
                <Link className="inline-block mr-4 py-0.5 text-xl whitespace-nowrap hover:no-underline focus:no-underline" to="/">

                    <img src={logo} alt={'Kanchaneshver Sales and Distribution Private Limited'} className="h-10 " />

                </Link>

                <button onClick={() => {
                    setOpen((current) => !current);
                    setPortalOpen(false);
                    setActivePortalSection(null);
                }} className="background-transparent rounded text-xl leading-none hover:no-underline focus:no-underline lg:hidden lg:text-gray-400" type="button" data-toggle="offcanvas">

                    <span className="navbar-toggler-icon inline-block w-8 h-8 align-middle"></span>
                </button>

                <div className={`navbar-collapse offcanvas-collapse lg:flex lg:grow lg:items-center ${open ? 'open' : ''}`} id="navbarsExampleDefault">
                    <ul className="pl-0 mt-3 mb-2 ml-auto flex flex-col list-none lg:mt-0 lg:mb-0 lg:flex-row">
                        <li>
                            <NavLink end onClick={closeMobileMenu} className={({ isActive }) => `nav-link page-scroll ${isActive ? "active" : ""}`} to="/">Home</NavLink>


                        </li>
                        <li>
                            <NavLink onClick={closeMobileMenu} className={({ isActive }) => `nav-link page-scroll ${isActive ? "active" : ""}`} to="/about">About Us</NavLink>

                        </li>
                        <li>
                            <NavLink onClick={closeMobileMenu} className={({ isActive }) => `nav-link page-scroll ${isActive ? "active" : ""}`} to="/services">Services</NavLink>

                        </li>
                        <li>
                            <NavLink onClick={closeMobileMenu} className={({ isActive }) => `nav-link page-scroll ${isActive ? "active" : ""}`} to="/contact">Contact Us</NavLink>

                        </li>

                        <li
                            ref={portalDropdownRef}
                            className={`dropdown portal-dropdown ${portalOpen ? 'portal-dropdown--open' : ''}`}
                            onMouseEnter={() => openPortalMenu()}
                            onFocus={() => openPortalMenu()}
                            onKeyDown={handlePortalKeyDown}
                        >
                            <button
                                className="nav-link dropdown-toggle nav-link-portal portal-toggle"
                                type="button"
                                aria-haspopup="true"
                                aria-expanded={portalOpen}
                                onClick={() => {
                                    setPortalOpen((current) => !current);
                                    setActivePortalSection(null);
                                }}
                            >
                                Portal
                            </button>


                            <div className="dropdown-menu portal-menu" aria-label="Portal links">
                                <div
                                    className={`portal-menu__group ${activePortalSection === 'login' ? 'portal-menu__group--active' : ''}`}
                                >
                                    <button className="portal-menu__category" type="button" onClick={() => openPortalMenu('login')}>
                                        <span className="portal-menu__category-icon">
                                            <LogIn size={18} strokeWidth={2.2} />
                                        </span>

                                        <span className="portal-menu__category-text">
                                            <span className="portal-menu__category-title">Login</span>
                                            <span className="portal-menu__category-copy">Access DSA, sales, payout and senior portals</span>

                                        </span>

                                        <ChevronRight className="portal-menu__category-arrow" size={18} strokeWidth={2.2} />
                                    </button>

                                    {activePortalSection === 'login' && (
                                        <div className="portal-menu__options">
                                            {loginLinks.map(item => (
                                                <a
                                                    key={item.id}
                                                    className="portal-menu__item"
                                                    href={getServerUrl(item.url)}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    onClick={closeMobileMenu}
                                                >

                                                    <span>{item.name}</span>
                                                    <ArrowUpRight size={14} strokeWidth={2.2} />
                                                </a>
                                            ))}
                                        </div>
                                    )}
                                </div>

                                <div
                                    className={`portal-menu__group ${activePortalSection === 'registration' ? 'portal-menu__group--active' : ''}`}
                                >
                                    <button className="portal-menu__category" type="button" onClick={() => openPortalMenu('registration')}>
                                        <span className="portal-menu__category-icon portal-menu__category-icon--registration">
                                            <UserPlus size={18} strokeWidth={2.2} />
                                        </span>

                                        <span className="portal-menu__category-text">
                                            <span className="portal-menu__category-title">Registration</span>
                                            <span className="portal-menu__category-copy">Create banker, DSA and associate registrations</span>
                                        </span>

                                        <ChevronRight className="portal-menu__category-arrow" size={18} strokeWidth={2.2} />
                                    </button>

                                    {activePortalSection === 'registration' && (
                                        <div className="portal-menu__options">
                                            {registrationLinks.map(item => (
                                                <a
                                                    key={item.id}
                                                    className="portal-menu__item"
                                                    href={getServerUrl(item.url)}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    onClick={closeMobileMenu}
                                                >
                                                    <span>{item.name}</span>
                                                    <ArrowUpRight size={14} strokeWidth={2.2} />
                                                </a>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </li>



                        <li className="dropdown" id="dropdown">
                            <Link className="nav-link dropdown-toggle" id="dropdown01" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Our Apps</Link>
                            <div className="dropdown-menu" aria-labelledby="dropdown01" id='dropdownmenu'>
                                <p className='px-4 py-2 cursor-default'>Android - Apps</p>
                                <div className="dropdown-divider" />
                                <Link onClick={closeMobileMenu} className="dropdown-item page-scroll text-sm !flex !gap-2 !flex-row cursor-pointer" target='_blank' to="https://play.google.com/store/apps/details?id=com.ns.ksdpl">
                                    <img src={playStoreLogo} alt="Sales App" className="text-indigo-600 hover:text-pink-500 size-6 transition-all duration-200" />
                                    <p>Sales App</p>
                                </Link>
                                <Link onClick={closeMobileMenu} className="dropdown-item page-scroll text-sm !flex !gap-2 !flex-row cursor-pointer" target='_blank' to="https://play.google.com/store/apps/details?id=com.dp.ksdpl_bankerapp">
                                    <img src={playStoreLogo} alt="Sales App" className="text-indigo-600 hover:text-pink-500 size-6 transition-all duration-200" />
                                    <p>Banker App</p>
                                </Link>
                                <Link onClick={closeMobileMenu} className="dropdown-item page-scroll text-sm !flex !gap-2 !flex-row cursor-pointer" target='_blank' to="https://play.google.com/store/apps/details?id=com.dp.ksdpl_customer">
                                    <img src={playStoreLogo} alt="Sales App" className="text-indigo-600 hover:text-pink-500 size-6 transition-all duration-200" />
                                    <p>Customer App</p>
                                </Link>
                                <div className="dropdown-divider" />
                                <p className='px-4 py-2 cursor-default'>Apple - Apps</p>
                                <div className="dropdown-divider" />

                                <Link
                                    onClick={closeMobileMenu}
                                    className="dropdown-item page-scroll text-sm !flex !gap-2 !flex-row cursor-pointer"
                                    target="_blank"
                                    to="https://apps.apple.com/in/app/ksdpl/id6758232819"
                                >
                                    <img
                                        src={appleStoreLogo}
                                        alt="App Store"
                                        className="text-indigo-600 hover:text-pink-500 size-6 transition-all duration-200 mr-1.5"
                                    />
                                    <p>Sales App</p>
                                </Link>

                                <Link
                                    onClick={closeMobileMenu}
                                    className="dropdown-item page-scroll text-sm !flex !gap-2 !flex-row cursor-pointer"
                                    target="_blank"
                                    to="https://apps.apple.com/us/app/myrinbazaar-banker/id6761003904"

                                >
                                    <img
                                        src={appleStoreLogo}
                                        alt="App Store"
                                        className="text-indigo-600 hover:text-pink-500 size-6 transition-all duration-200 mr-1.5"
                                    />
                                    <p>Banker App</p>
                                </Link>

                                <Link
                                    onClick={closeMobileMenu}
                                    className="dropdown-item page-scroll text-sm !flex !gap-2 !flex-row cursor-pointer"
                                    target="_blank"
                                    to="https://apps.apple.com/us/app/ksdpl-customer/id6759285045"
                                >
                                    <img
                                        src={appleStoreLogo}
                                        alt="App Store"
                                        className="text-indigo-600 hover:text-pink-500 size-6 transition-all duration-200 mr-1.5"
                                    />
                                    <p>Customer App</p>
                                </Link>

                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    )
}

export default Header
